import Vue from 'vue';
import VueCookies from 'vue-cookies';

VueCookies.config('5d');

Vue.use(VueCookies);
